import { spacing } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled.div``

export const ButtonContainer = styled.div`
  margin: 0 auto;
  margin-top: ${spacing(5)};
  display: flex;
  justify-content: center;
`
